// Generated by purs version 0.13.8
"use strict";
var $foreign = require("./foreign.js");
var Animation_Core = require("../Animation.Core/index.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_Error_Class = require("../Control.Monad.Error.Class/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Board = require("../Data.Board/index.js");
var Data_DateTime_Instant = require("../Data.DateTime.Instant/index.js");
var Data_Enemy = require("../Data.Enemy/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_FoldableWithIndex = require("../Data.FoldableWithIndex/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Int = require("../Data.Int/index.js");
var Data_Item = require("../Data.Item/index.js");
var Data_LinearIndex = require("../Data.LinearIndex/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_RevMap = require("../Data.RevMap/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Semiring = require("../Data.Semiring/index.js");
var Data_Set = require("../Data.Set/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_String_CodePoints = require("../Data.String.CodePoints/index.js");
var Data_String_Common = require("../Data.String.Common/index.js");
var Data_String_Pattern = require("../Data.String.Pattern/index.js");
var Data_Terrain = require("../Data.Terrain/index.js");
var Data_Time_Duration = require("../Data.Time.Duration/index.js");
var Data_Traversable = require("../Data.Traversable/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Effect = require("../Effect/index.js");
var Effect_Exception = require("../Effect.Exception/index.js");
var Effect_Ref = require("../Effect.Ref/index.js");
var Extra_Math = require("../Extra.Math/index.js");
var GameState = require("../GameState/index.js");
var Graphics_Canvas = require("../Graphics.Canvas/index.js");
var $$Math = require("../Math/index.js");
var UI = require("../UI/index.js");
var RendererState = function (x) {
    return x;
};
var Color = function (x) {
    return x;
};
var splitOnSize = function (s) {
    return function (size) {
        var splits = Data_String_Common.split(" ")(s);
        var lens = Data_Traversable.scanl(Data_Traversable.traversableArray)(function (b) {
            return function (a) {
                return b + Data_String_CodePoints.length(a) | 0;
            };
        })(0)(splits);
        var splens = Data_Array.zip(lens)(splits);
        var rest = Data_Functor.map(Data_Functor.functorArray)(Data_Tuple.snd)(Data_Array.dropWhile(function (x) {
            return Data_Tuple.fst(x) < size;
        })(splens));
        var trail = Data_String_Common.joinWith(" ")(rest);
        var start = Data_String_Common.joinWith(" ")(Data_Functor.map(Data_Functor.functorArray)(Data_Tuple.snd)(Data_Array.takeWhile(function (x) {
            return Data_Tuple.fst(x) < size;
        })(splens)));
        var v = Data_String_CodePoints.length(start) > 0;
        var v1 = Data_Array.length(rest) > 0;
        if (v1 && v) {
            return Data_Semigroup.append(Data_Semigroup.semigroupArray)([ start ])(splitOnSize(trail)(size));
        };
        if (v) {
            return [ start ];
        };
        if (!v) {
            return rest;
        };
        throw new Error("Failed pattern match at Graphics.Render (line 587, column 6 - line 590, column 24): " + [ v1.constructor.name, v.constructor.name ]);
    };
};
var screenImageData = function (v) {
    return function __do() {
        var ctx = Graphics_Canvas.getContext2D(v.canvas)();
        return Graphics_Canvas.getImageData(ctx)(UI.screen.x)(UI.screen.y)(UI.screen.width)(UI.screen.height)();
    };
};
var restore = function (v) {
    return function (rect) {
        return function __do() {
            var ctx = Graphics_Canvas.getContext2D(v.cvars.canvas)();
            var id = Effect_Ref.read(v.screenCache)();
            return Graphics_Canvas.putImageDataFull(ctx)(id)(0.0)(0.0)(rect.x)(rect.y)(rect.width)(rect.height)();
        };
    };
};
var restoreAll = function (v) {
    return function __do() {
        var rects = Effect_Ref.read(v.toRestore)();
        Data_Foldable.for_(Effect.applicativeEffect)(Data_Foldable.foldableArray)(rects)(restore(v))();
        return Effect_Ref.write([  ])(v.toRestore)();
    };
};
var rectPos = function (v) {
    return {
        x: v.x,
        y: v.y
    };
};
var queueRestore = function (v) {
    return function (rect) {
        return Effect_Ref.modify_(Data_Array.cons(rect))(v.toRestore);
    };
};
var organImage = function (ot) {
    return function (v) {
        if (v) {
            return (Data_Board.organImages(ot)).base;
        };
        if (!v) {
            return (Data_Board.organImages(ot)).hurt;
        };
        throw new Error("Failed pattern match at Graphics.Render (line 527, column 1 - line 527, column 45): " + [ ot.constructor.name, v.constructor.name ]);
    };
};
var note = function (v) {
    return Effect_Ref.modify_(function (x) {
        return x + 1 | 0;
    })(v.debug);
};
var initDebug = 0;
var newRendererState = function (cvars) {
    return function __do() {
        var gameStateId = Effect_Ref["new"](Data_Maybe.Nothing.value)();
        var uiStateId = Effect_Ref["new"](Data_Maybe.Nothing.value)();
        var toRestore = Effect_Ref["new"]([  ])();
        var sid = screenImageData(cvars)();
        var screenCache = Effect_Ref["new"](sid)();
        var debug = Effect_Ref["new"](initDebug)();
        return {
            cvars: cvars,
            gameStateId: gameStateId,
            uiStateId: uiStateId,
            toRestore: toRestore,
            screenCache: screenCache,
            debug: debug
        };
    };
};
var resetDebug = function (v) {
    return Effect_Ref.write(initDebug)(v.debug);
};
var getHighlightColor = function (t) {
    var ms = Data_Newtype.un(Data_Time_Duration.newtypeMilliseconds)(Data_Time_Duration.Milliseconds)(Data_DateTime_Instant.unInstant(t));
    var opacity = Data_Int.toStringAs(Data_Int.hexadecimal)(Data_Int.floor($$Math.sin(ms / 100.0) * 30.0 + 120.0));
    return Color("#ffffff" + opacity);
};
var fromGrid = function (p) {
    return Data_Functor.mapFlipped(Extra_Math.functorVector)(p)(function (x) {
        return Extra_Math.toNumber(Extra_Math.realInt)(x) * UI.tileSize;
    });
};
var fillRect = function (v) {
    return function (rect) {
        return function (v1) {
            return function __do() {
                var ctx = Graphics_Canvas.getContext2D(v.cvars.canvas)();
                Graphics_Canvas.setFillStyle(ctx)(v1)();
                return Graphics_Canvas.fillRect(ctx)(rect)();
            };
        };
    };
};
var fillRectTemp = function (rs) {
    return function (rect) {
        return function (color) {
            return function __do() {
                fillRect(rs)(rect)(color)();
                return queueRestore(rs)({
                    height: rect.height + 1.0,
                    width: rect.width + 1.0,
                    x: rect.x,
                    y: rect.y
                })();
            };
        };
    };
};
var drawImageFull = function (v) {
    return function (path) {
        return function (s) {
            return function (d) {
                return function __do() {
                    note(v)();
                    var ctx = Graphics_Canvas.getContext2D(v.cvars.canvas)();
                    var imageMap = Effect_Ref.read(v.cvars.imageData.index)();
                    var images = Effect_Ref.read(v.cvars.imageData.array)();
                    var im = Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Map_Internal.lookup(Data_Ord.ordString)(path)(imageMap))(function (v1) {
                        return Data_Array.index(images)(v1);
                    });
                    if (im instanceof Data_Maybe.Nothing) {
                        return Control_Monad_Error_Class.throwError(Control_Monad_Error_Class.monadThrowEffect)(Effect_Exception.error("Missing image!"))();
                    };
                    if (im instanceof Data_Maybe.Just) {
                        return Graphics_Canvas.drawImageFull(ctx)(im.value0)(s.x)(s.y)(s.width)(s.height)(d.x)(d.y)(d.width)(d.height)();
                    };
                    throw new Error("Failed pattern match at Graphics.Render (line 629, column 3 - line 633, column 34): " + [ im.constructor.name ]);
                };
            };
        };
    };
};
var drawImage = function (v) {
    return function (path) {
        return function (v1) {
            return function __do() {
                note(v)();
                var ctx = Graphics_Canvas.getContext2D(v.cvars.canvas)();
                var imageMap = Effect_Ref.read(v.cvars.imageData.index)();
                var images = Effect_Ref.read(v.cvars.imageData.array)();
                var im = Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Map_Internal.lookup(Data_Ord.ordString)(path)(imageMap))(function (v2) {
                    return Data_Array.index(images)(v2);
                });
                if (im instanceof Data_Maybe.Nothing) {
                    return Control_Monad_Error_Class.throwError(Control_Monad_Error_Class.monadThrowEffect)(Effect_Exception.error("Missing image!"))();
                };
                if (im instanceof Data_Maybe.Just) {
                    return Graphics_Canvas.drawImageScale(ctx)(im.value0)(v1.x)(v1.y)(v1.width)(v1.height)();
                };
                throw new Error("Failed pattern match at Graphics.Render (line 616, column 3 - line 618, column 66): " + [ im.constructor.name ]);
            };
        };
    };
};
var drawImageTemp = function (rs) {
    return function (img) {
        return function (rect) {
            return function __do() {
                drawImage(rs)(img)(rect)();
                return queueRestore(rs)({
                    x: rect.x - 1.0,
                    y: rect.y - 1.0,
                    width: rect.width + 2.0,
                    height: rect.height + 2.0
                })();
            };
        };
    };
};
var drawOrganTemp = function (isIntact) {
    return function (rs) {
        return function (v) {
            return function (v1) {
                return drawImageTemp(rs)(organImage(v.value1)(isIntact))({
                    x: v1.x,
                    y: v1.y,
                    width: UI.tileSize * Extra_Math.toNumber(Extra_Math.realInt)(v.value0.value0),
                    height: UI.tileSize * Extra_Math.toNumber(Extra_Math.realInt)(v.value0.value1)
                });
            };
        };
    };
};
var drawOrgan = function (isIntact) {
    return function (rs) {
        return function (v) {
            return function (v1) {
                return drawImage(rs)(organImage(v.value1)(isIntact))({
                    x: v1.x,
                    y: v1.y,
                    width: UI.tileSize * Extra_Math.toNumber(Extra_Math.realInt)(v.value0.value0),
                    height: UI.tileSize * Extra_Math.toNumber(Extra_Math.realInt)(v.value0.value1)
                });
            };
        };
    };
};
var drawInjury = drawOrgan(false);
var drawRedVision = function (rs) {
    return function (v) {
        var playerBoard = (Data_Newtype.un(Data_Board.newtypeHealth)(Data_Board.Health)(v.playerHealth)).board;
        var $144 = Data_Board.hasRedEye(playerBoard);
        if ($144) {
            return drawImage(rs)("Eye2.png")({
                x: UI.tileSize * 2.0,
                y: 0.0,
                width: UI.tileSize,
                height: UI.tileSize
            });
        };
        return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
    };
};
var drawHighlights = function (t) {
    return function (v) {
        return function (rs) {
            var color = getHighlightColor(t);
            return Data_Foldable.for_(Effect.applicativeEffect)(Data_Foldable.foldableArray)(v.highlights)(function (rect) {
                return fillRectTemp(rs)(rect)(color);
            });
        };
    };
};
var drawDraggedOrgan = function (v) {
    return function (gs) {
        return function (v1) {
            if (v.draggingOrgan instanceof Data_Maybe.Nothing) {
                return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
            };
            if (v.draggingOrgan instanceof Data_Maybe.Just) {
                var v2 = Data_Semiring.add(Extra_Math.semiringVector(Data_Semiring.semiringNumber))(rectPos(UI.centerPaneRect))(fromGrid(v.draggingOrgan.value0.organ.value1));
                var width = Extra_Math.toNumber(Extra_Math.realInt)(v.draggingOrgan.value0.organ.value0.value0.value0) * UI.tileSize;
                var height = Extra_Math.toNumber(Extra_Math.realInt)(v.draggingOrgan.value0.organ.value0.value0.value1) * UI.tileSize;
                return function __do() {
                    fillRectTemp(v1)({
                        x: v2.x,
                        y: v2.y,
                        width: width,
                        height: height
                    })("black")();
                    var v3 = Data_Semiring.add(Extra_Math.semiringVector(Data_Semiring.semiringNumber))(v2)(v.draggingOrgan.value0.offset);
                    return drawOrganTemp(true)(v1)(v.draggingOrgan.value0.organ.value0)(v3)();
                };
            };
            throw new Error("Failed pattern match at Graphics.Render (line 379, column 3 - line 390, column 44): " + [ v.draggingOrgan.constructor.name ]);
        };
    };
};
var drawColorText = function (v) {
    return function (size) {
        return function (string) {
            return function (v1) {
                return function (v2) {
                    return function __do() {
                        var ctx = Graphics_Canvas.getContext2D(v.cvars.canvas)();
                        Graphics_Canvas.setFont(ctx)(Data_Show.show(Data_Show.showInt)(Data_Int.round(size)) + "px CapitalHillMono")();
                        $foreign.setTextBaselineHanging(ctx)();
                        Graphics_Canvas.setFillStyle(ctx)(v1)();
                        return Graphics_Canvas.fillText(ctx)(string)(v2.x + 5.0)(v2.y + 5.0)();
                    };
                };
            };
        };
    };
};
var drawText = function (vars) {
    return function (size) {
        return function (string) {
            return function (loc) {
                return drawColorText(vars)(size)(string)("white")(loc);
            };
        };
    };
};
var drawDeathMessage = function (rs) {
    return function __do() {
        drawText(rs)(UI.tileSize)("You have")({
            x: 0.0,
            y: UI.tileSize * 8.0
        })();
        return drawText(rs)(UI.tileSize)("died")({
            x: 1.5 * UI.tileSize,
            y: UI.tileSize * 9.0
        })();
    };
};
var drawHp = function (rs) {
    return function (v) {
        var playerHp = (Data_Newtype.un(Data_Board.newtypeHealth)(Data_Board.Health)(v.playerHealth)).hpCount;
        return function __do() {
            drawText(rs)(UI.tileSize)(Data_Show.show(Data_Show.showInt)(playerHp))({
                x: UI.tileSize,
                y: 0.0
            })();
            return drawImage(rs)("heart.png")({
                x: 0.0,
                y: 0.0,
                width: UI.tileSize,
                height: UI.tileSize
            })();
        };
    };
};
var wrapText = function (vars) {
    return function (string) {
        return function (v) {
            return function (_maxWidth) {
                var splits = splitOnSize(string)(11);
                var indices = Data_Traversable.scanl(Data_Traversable.traversableArray)(function (b) {
                    return function (a) {
                        return 1 + b | 0;
                    };
                })(0)(splits);
                var splens = Data_Array.zip(indices)(splits);
                return Data_Foldable.for_(Effect.applicativeEffect)(Data_Foldable.foldableArray)(splens)(function (v1) {
                    return drawText(vars)(UI.tileSize)(v1.value1)({
                        x: v.x,
                        y: v.y + UI.tileSize * Extra_Math.toNumber(Extra_Math.realInt)(v1.value0 - 1 | 0)
                    });
                });
            };
        };
    };
};
var drawClue = function (rs) {
    return function (v) {
        return function (p) {
            if (v instanceof Data_Board.HpClue) {
                return drawColorText(rs)(UI.tileSize)(Data_Show.show(Data_Show.showInt)(v.value0))("#a00")(p);
            };
            if (v instanceof Data_Board.ArmorClue) {
                return drawColorText(rs)(UI.tileSize)(Data_Show.show(Data_Show.showInt)(v.value0))("blue")(p);
            };
            if (v instanceof Data_Board.MixedClue) {
                return drawColorText(rs)(UI.tileSize)(Data_Show.show(Data_Show.showInt)(v.value0))("purple")(p);
            };
            if (v instanceof Data_Board.EmptyClue) {
                return drawColorText(rs)(UI.tileSize)("0")("#777")(p);
            };
            if (v instanceof Data_Board.ConcealedClue) {
                return drawColorText(rs)(UI.tileSize)("?")("#333")(p);
            };
            throw new Error("Failed pattern match at Graphics.Render (line 544, column 1 - line 544, column 66): " + [ rs.constructor.name, v.constructor.name, p.constructor.name ]);
        };
    };
};
var drawEnemyBoardDetails = function (rs) {
    return function (v) {
        return function (v1) {
            var anchor = {
                x: UI.targetBoardRect.x,
                y: UI.targetBoardRect.y
            };
            return Data_Foldable.for_(Effect.applicativeEffect)(Data_Set.foldableSet)((Data_Newtype.un(Data_Board.newtypeBoard)(Data_Board.Board)(v.health.board)).injuries)(function (v2) {
                var drawPos = Data_Semiring.add(Extra_Math.semiringVector(Data_Semiring.semiringNumber))(fromGrid(v2))(anchor);
                var v3 = Data_Board.getOrganAtPosition(v.health.board)(v2);
                if (v3 instanceof Data_Maybe.Just) {
                    return drawInjury(rs)(v3.value0)(drawPos);
                };
                if (v3 instanceof Data_Maybe.Nothing) {
                    var v4 = Data_Map_Internal.lookup(Extra_Math.ordVector(Data_Ord.ordInt))(v2)(v.clueCache);
                    if (v4 instanceof Data_Maybe.Just) {
                        return drawClue(rs)(Data_Board.restrictClue(v1.playerHealth)(v4.value0))(drawPos);
                    };
                    if (v4 instanceof Data_Maybe.Nothing) {
                        return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
                    };
                    throw new Error("Failed pattern match at Graphics.Render (line 517, column 22 - line 522, column 47): " + [ v4.constructor.name ]);
                };
                throw new Error("Failed pattern match at Graphics.Render (line 515, column 9 - line 522, column 47): " + [ v3.constructor.name ]);
            });
        };
    };
};
var drawBoardBase = function (vars) {
    return function (v) {
        return function (v1) {
            return Data_Foldable.for_(Effect.applicativeEffect)(Data_Foldable.foldableArray)(Data_Array.range(0)(5))(function (px) {
                return Data_Foldable.for_(Effect.applicativeEffect)(Data_Foldable.foldableArray)(Data_Array.range(0)(5))(function (py) {
                    var buttonImage = (function () {
                        var $205 = Data_Set.member(Extra_Math.ordVector(Data_Ord.ordInt))({
                            x: px,
                            y: py
                        })(v.injuries);
                        if ($205) {
                            return "ButtonPushed.png";
                        };
                        return "ButtonUnpushed.png";
                    })();
                    return drawImage(vars)(buttonImage)({
                        x: v1.x + Extra_Math.toNumber(Extra_Math.realInt)(px) * UI.tileSize,
                        y: v1.y + Extra_Math.toNumber(Extra_Math.realInt)(py) * UI.tileSize,
                        width: UI.tileSize,
                        height: UI.tileSize
                    });
                });
            });
        };
    };
};
var drawBlueVision = function (rs) {
    return function (v) {
        var playerBoard = (Data_Newtype.un(Data_Board.newtypeHealth)(Data_Board.Health)(v.playerHealth)).board;
        var $211 = Data_Board.hasBlueEye(playerBoard);
        if ($211) {
            return drawImage(rs)("Eye3.png")({
                x: UI.tileSize * 4.0,
                y: 0.0,
                width: UI.tileSize,
                height: UI.tileSize
            });
        };
        return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
    };
};
var drawStats = function (rs) {
    return function (gs) {
        return function __do() {
            drawHp(rs)(gs)();
            drawRedVision(rs)(gs)();
            return drawBlueVision(rs)(gs)();
        };
    };
};
var debugInfo = function (v) {
    return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
};
var clear = function (rs) {
    return function (rect) {
        return fillRect(rs)(rect)("black");
    };
};
var drawPlayerBoard = function (t) {
    return function (uis) {
        return function (v) {
            return function (rs) {
                var playerHp = (Data_Newtype.un(Data_Board.newtypeHealth)(Data_Board.Health)(v.playerHealth)).hpCount;
                var playerBoard = (Data_Newtype.un(Data_Board.newtypeHealth)(Data_Board.Health)(v.playerHealth)).board;
                var playerOrgans = Data_Board.getOrgans(playerBoard);
                var anchor = {
                    x: UI.playerBoardRect.x,
                    y: UI.playerBoardRect.y
                };
                return function __do() {
                    clear(rs)(UI.leftPaneRect)();
                    drawStats(rs)(v)();
                    drawBoardBase(rs)(playerBoard)(UI.playerBoardRect)();
                    Data_Foldable.for_(Effect.applicativeEffect)(Data_Foldable.foldableArray)(playerOrgans.intact)(function (v1) {
                        return drawOrgan(true)(rs)(v1.value0)(Data_Semiring.add(Extra_Math.semiringVector(Data_Semiring.semiringNumber))(fromGrid(v1.value1))(anchor));
                    })();
                    Data_Foldable.for_(Effect.applicativeEffect)(Data_Foldable.foldableArray)(playerOrgans.injured)(function (v1) {
                        return drawOrgan(false)(rs)(v1.value0)(Data_Semiring.add(Extra_Math.semiringVector(Data_Semiring.semiringNumber))(fromGrid(v1.value1))(anchor));
                    })();
                    var $226 = playerHp <= 0;
                    if ($226) {
                        return drawDeathMessage(rs)();
                    };
                    return Data_Unit.unit;
                };
            };
        };
    };
};
var drawRightPane = function (t) {
    return function (v) {
        return function (v1) {
            return function (rs) {
                return function __do() {
                    clear(rs)(UI.rightPaneRect)();
                    (function () {
                        if (v.itemTarget instanceof UI.RPItem) {
                            var v2 = Data_Map_Internal.lookup(Data_Ord.ordInt)(v.itemTarget.value0)(v1.items);
                            if (v2 instanceof Data_Maybe.Nothing) {
                                return Data_Unit.unit;
                            };
                            if (v2 instanceof Data_Maybe.Just) {
                                drawText(rs)(UI.tileSize)("Item")({
                                    x: UI.targetBoardContainerRect.x,
                                    y: UI.targetBoardContainerRect.y + UI.targetBoardContainerRect.height + UI.tileSize * 2.0
                                })();
                                drawText(rs)(UI.tileSize)("turns")({
                                    x: UI.targetBoardContainerRect.x,
                                    y: UI.targetBoardContainerRect.y + UI.targetBoardContainerRect.height + UI.tileSize * 3.0
                                })();
                                drawText(rs)(UI.tileSize)("remaining:")({
                                    x: UI.targetBoardContainerRect.x,
                                    y: UI.targetBoardContainerRect.y + UI.targetBoardContainerRect.height + UI.tileSize * 4.0
                                })();
                                return drawText(rs)(UI.tileSize)(Data_Show.show(Data_Show.showInt)(v2.value0.decay))({
                                    x: UI.targetBoardContainerRect.x,
                                    y: UI.targetBoardContainerRect.y + UI.targetBoardContainerRect.height + UI.tileSize * 5.0
                                })();
                            };
                            throw new Error("Failed pattern match at Graphics.Render (line 438, column 19 - line 456, column 13): " + [ v2.constructor.name ]);
                        };
                        return Data_Unit.unit;
                    })();
                    if (v.rightPaneTarget instanceof UI.RPEnemy) {
                        var v2 = Data_Map_Internal.lookup(Data_Ord.ordInt)(v.rightPaneTarget.value0)(v1.enemies);
                        if (v2 instanceof Data_Maybe.Nothing) {
                            return Data_Unit.unit;
                        };
                        if (v2 instanceof Data_Maybe.Just) {
                            var name = Data_Enemy.name(v2.value0);
                            var nameLoc = {
                                x: UI.rightPaneRect.x,
                                y: UI.rightPaneRect.y
                            };
                            wrapText(rs)(name)(nameLoc)(UI.rightPaneRect.width)();
                            drawImage(rs)("heart.png")({
                                x: UI.targetBoardContainerRect.x,
                                y: UI.targetBoardContainerRect.y,
                                width: UI.tileSize,
                                height: UI.tileSize
                            })();
                            drawText(rs)(UI.tileSize)(Data_Show.show(Data_Show.showInt)(v2.value0.health.hpCount))({
                                x: UI.targetBoardContainerRect.x + UI.tileSize,
                                y: UI.targetBoardContainerRect.y
                            })();
                            drawImage(rs)("Armor5.png")({
                                x: UI.targetBoardContainerRect.x + UI.tileSize * 3.0,
                                y: UI.targetBoardContainerRect.y,
                                width: UI.tileSize,
                                height: UI.tileSize
                            })();
                            drawText(rs)(UI.tileSize)(Data_Show.show(Data_Show.showInt)(v2.value0.health.armorCount))({
                                x: UI.targetBoardContainerRect.x + UI.tileSize * 4.0,
                                y: UI.targetBoardContainerRect.y
                            })();
                            drawBoardBase(rs)(v2.value0.health.board)(UI.targetBoardRect)();
                            return drawEnemyBoardDetails(rs)(v2.value0)(v1)();
                        };
                        throw new Error("Failed pattern match at Graphics.Render (line 459, column 23 - line 483, column 45): " + [ v2.constructor.name ]);
                    };
                    return Data_Unit.unit;
                };
            };
        };
    };
};
var centerPaneMap = function (t) {
    return function (v) {
        return function (v1) {
            return function (rs) {
                return function __do() {
                    clear(rs)(UI.centerPaneRect)();
                    return Data_Foldable.for_(Effect.applicativeEffect)(Data_Map_Internal.foldableMap)(v1.rooms)(function (v2) {
                        return Control_Applicative.when(Effect.applicativeEffect)(v2.visible)(Data_Foldable.for_(Effect.applicativeEffect)(Data_Foldable.foldableArray)(Data_Terrain.blockPositions(v2.perimeter))(function (pos) {
                            var y = Extra_Math.toNumber(Extra_Math.realInt)(pos.y) * UI.tileSize;
                            var x = UI.centerPaneRect.x + Extra_Math.toNumber(Extra_Math.realInt)(pos.x) * UI.tileSize;
                            var terrain = Data_Maybe.fromMaybe(Data_Terrain.Floor.value)(Data_LinearIndex.index(v1.terrain)(pos));
                            var image = (function () {
                                if (terrain instanceof Data_Terrain.Wall) {
                                    return "wall.png";
                                };
                                if (terrain instanceof Data_Terrain.Floor) {
                                    return "ground.png";
                                };
                                if (terrain instanceof Data_Terrain.Exit) {
                                    return "exit.png";
                                };
                                if (terrain instanceof Data_Terrain.DoorClosed) {
                                    return "doorclosed.png";
                                };
                                if (terrain instanceof Data_Terrain.DoorOpen) {
                                    return "dooropen.png";
                                };
                                throw new Error("Failed pattern match at Graphics.Render (line 344, column 19 - line 349, column 46): " + [ terrain.constructor.name ]);
                            })();
                            return drawImage(rs)(image)({
                                x: x,
                                y: y,
                                width: UI.tileSize,
                                height: UI.tileSize
                            });
                        }));
                    })();
                };
            };
        };
    };
};
var cacheScreen = function (v) {
    return function __do() {
        var imageData = screenImageData(v.cvars)();
        return Effect_Ref.write(imageData)(v.screenCache)();
    };
};
var blink = function (t) {
    return function (f) {
        var ms = Data_Newtype.un(Data_Time_Duration.newtypeMilliseconds)(Data_Time_Duration.Milliseconds)(Data_DateTime_Instant.unInstant(t));
        var interval = 100.0 + Extra_Math.toNumber(Extra_Math.realInt)(f) * 100.0;
        return $$Math.remainder(ms)(interval) > 100.0;
    };
};
var animPlayerRect = function (t) {
    return function (v) {
        return function (v1) {
            var v2 = Data_Functor.map(Extra_Math.functorVector)($$Math.round)(Data_Semiring.add(Extra_Math.semiringVector(Data_Semiring.semiringNumber))(Data_Semiring.add(Extra_Math.semiringVector(Data_Semiring.semiringNumber))(rectPos(UI.centerPaneRect))(fromGrid(v1.p)))(Animation_Core.resolve(t)(v.playerAnim)));
            return {
                x: v2.x,
                y: v2.y,
                width: UI.tileSize,
                height: UI.tileSize
            };
        };
    };
};
var animItemRect = function (t) {
    return function (iid) {
        return function (v) {
            return function (v1) {
                return function (v2) {
                    var v3 = Data_Functor.map(Extra_Math.functorVector)($$Math.round)(Data_Semiring.add(Extra_Math.semiringVector(Data_Semiring.semiringNumber))(rectPos(UI.centerPaneRect))(fromGrid(v.location)));
                    return {
                        x: v3.x,
                        y: v3.y,
                        width: UI.tileSize,
                        height: UI.tileSize
                    };
                };
            };
        };
    };
};
var animEnemyRect = function (t) {
    return function (eid) {
        return function (v) {
            return function (v1) {
                return function (v2) {
                    var shift = Data_Maybe.fromMaybe(Data_Semiring.zero(Extra_Math.semiringVector(Data_Semiring.semiringNumber)))(Data_Functor.map(Data_Maybe.functorMaybe)(Animation_Core.resolve(t))(Data_Map_Internal.lookup(Data_Ord.ordInt)(eid)(v1.enemyAnim)));
                    var v3 = Data_Functor.map(Extra_Math.functorVector)($$Math.round)(Data_Semiring.add(Extra_Math.semiringVector(Data_Semiring.semiringNumber))(Data_Semiring.add(Extra_Math.semiringVector(Data_Semiring.semiringNumber))(rectPos(UI.centerPaneRect))(fromGrid(v.location)))(shift));
                    return {
                        x: v3.x,
                        y: v3.y,
                        width: UI.tileSize,
                        height: UI.tileSize
                    };
                };
            };
        };
    };
};
var drawCenterPaneAnimations = function (t) {
    return function (v) {
        return function (v1) {
            return function (v2) {
                return function __do() {
                    drawImageTemp(v2)("player.png")(animPlayerRect(t)(v)(v1))();
                    Data_FoldableWithIndex.forWithIndex_(Effect.applicativeEffect)(Data_Map_Internal.foldableWithIndexMap)(v1.items)(function (iid) {
                        return function (v3) {
                            var rect = animItemRect(t)(iid)(v3)(v)(v1);
                            var image = Data_Item.image(v3);
                            return Control_Applicative.when(Effect.applicativeEffect)(blink(t)(v3.decay))(drawImageTemp(v2)(image)(rect));
                        };
                    })();
                    return Data_FoldableWithIndex.forWithIndex_(Effect.applicativeEffect)(Data_Map_Internal.foldableWithIndexMap)(v1.enemies)(function (eid) {
                        return function (nme) {
                            var rect = animEnemyRect(t)(eid)(nme)(v)(v1);
                            var image = Data_Enemy.image(nme);
                            return drawImageTemp(v2)(image)(rect);
                        };
                    })();
                };
            };
        };
    };
};
var drawCenterPane = function (t) {
    return function (v) {
        return function (v1) {
            return function (v2) {
                return function __do() {
                    var prevGS = Effect_Ref.read(v2.gameStateId)();
                    var gsDirty = Data_Maybe.maybe(true)(Data_Ord.greaterThan(Data_DateTime_Instant.ordDateTime)(v.gsTimestamp))(prevGS);
                    (function () {
                        if (v1.level instanceof GameState.NewGame) {
                            clear(v2)(UI.centerPaneRect)();
                            var y = (UI.centerPaneRect.y + UI.centerPaneRect.height) - UI.tileSize * 8.0;
                            var size = UI.tileSize / 2.0;
                            var say = function (s) {
                                return function (p) {
                                    return drawText(v2)(size)(s)(p);
                                };
                            };
                            say("You have been stranded on the dump moon Detritus-7.")({
                                x: UI.centerPaneRect.x,
                                y: y
                            })();
                            say("It is swarming with deadly robots.")({
                                x: UI.centerPaneRect.x,
                                y: y + UI.tileSize * 1.0
                            })();
                            say("Can you escape before they overwhelm you?")({
                                x: UI.centerPaneRect.x,
                                y: y + UI.tileSize * 2.0
                            })();
                            say("Press any key to start")({
                                x: UI.centerPaneRect.x,
                                y: y + UI.tileSize * 4.0
                            })();
                            return cacheScreen(v2)();
                        };
                        if (v1.level instanceof GameState.Victory) {
                            clear(v2)(UI.centerPaneRect)();
                            var y = (UI.centerPaneRect.y + UI.centerPaneRect.height) - UI.tileSize * 8.0;
                            var size = UI.tileSize / 2.0;
                            var say = function (s) {
                                return function (p) {
                                    return drawText(v2)(size)(s)(p);
                                };
                            };
                            var organs = Data_RevMap.values(Extra_Math.ordVector(Data_Ord.ordInt))(v1.playerHealth.board.organs);
                            var freshOrgans = Data_RevMap.values(Extra_Math.ordVector(Data_Ord.ordInt))(GameState.freshPlayerOrgans);
                            var originalOrgansRemaining = Data_Array.length(Data_Array.intersect(Data_Tuple.eqTuple(Data_Board.eqOrgan)(Extra_Math.eqVector(Data_Eq.eqInt)))(organs)(freshOrgans));
                            say("You have escaped from the dump moon. Victory!")({
                                x: UI.centerPaneRect.x,
                                y: y
                            })();
                            say("But at what cost?")({
                                x: UI.centerPaneRect.x,
                                y: y + UI.tileSize * 2.0
                            })();
                            say(Data_String_Common.replace("{n}")(Data_String_Pattern.Replacement(Data_Show.show(Data_Show.showInt)(v1.installedOrgans)))("You implanted {n} strange parts."))({
                                x: UI.centerPaneRect.x,
                                y: y + UI.tileSize * 3.0
                            })();
                            return cacheScreen(v2)();
                        };
                        if (v1.level instanceof GameState.Dead) {
                            clear(v2)(UI.centerPaneRect)();
                            var y = (UI.centerPaneRect.y + UI.centerPaneRect.height) - UI.tileSize * 4.0;
                            var size = UI.tileSize / 2.0;
                            var say = function (s) {
                                return function (p) {
                                    return drawText(v2)(size)(s)(p);
                                };
                            };
                            say("You died. Press any key to try again.")({
                                x: UI.centerPaneRect.x,
                                y: y
                            })();
                            return cacheScreen(v2)();
                        };
                        if (v1.level instanceof GameState.Regular) {
                            Control_Applicative.when(Effect.applicativeEffect)(gsDirty)(function __do() {
                                centerPaneMap(t)(v)(v1)(v2)();
                                cacheScreen(v2)();
                                return Effect_Ref.write(new Data_Maybe.Just(v.gsTimestamp))(v2.gameStateId)();
                            })();
                            return drawCenterPaneAnimations(t)(v)(v1)(v2)();
                        };
                        if (v1.level instanceof GameState.Surgery) {
                            return Control_Applicative.when(Effect.applicativeEffect)(gsDirty)(function __do() {
                                clear(v2)(UI.centerPaneRect)();
                                Data_Foldable.for_(Effect.applicativeEffect)(Data_Foldable.foldableArray)(Data_Board.organArray(v1.availableOrgans))(function (v3) {
                                    return drawOrgan(true)(v2)(v3.value0)(Data_Semiring.add(Extra_Math.semiringVector(Data_Semiring.semiringNumber))(rectPos(UI.centerPaneRect))(fromGrid(v3.value1)));
                                })();
                                var y = (UI.centerPaneRect.y + UI.centerPaneRect.height) - UI.tileSize * 4.0;
                                var size = UI.tileSize / 2.0;
                                var say = function (s) {
                                    return function (p) {
                                        return drawText(v2)(size)(s)(p);
                                    };
                                };
                                say("Drag parts into your health area to install them")({
                                    x: UI.centerPaneRect.x,
                                    y: y
                                })();
                                say("Click on parts in your health to destroy them")({
                                    x: UI.centerPaneRect.x,
                                    y: y + size
                                })();
                                say("Press any key to go to the next level")({
                                    x: UI.centerPaneRect.x,
                                    y: y + size * 2.0
                                })();
                                return cacheScreen(v2)();
                            })();
                        };
                        throw new Error("Failed pattern match at Graphics.Render (line 267, column 3 - line 332, column 26): " + [ v1.level.constructor.name ]);
                    })();
                    return Effect_Ref.write(new Data_Maybe.Just(v.gsTimestamp))(v2.gameStateId)();
                };
            };
        };
    };
};
var draw = function (t) {
    return function (v) {
        return function (v1) {
            return function (v2) {
                return function __do() {
                    var prevUI = Effect_Ref.read(v2.uiStateId)();
                    resetDebug(v2)();
                    restoreAll(v2)();
                    var uiDirty = Data_Maybe.maybe(true)(Data_Ord.greaterThan(Data_DateTime_Instant.ordDateTime)(v.timestamp))(prevUI);
                    drawCenterPane(t)(v)(v1)(v2)();
                    Control_Applicative.when(Effect.applicativeEffect)(uiDirty)(function __do() {
                        drawPlayerBoard(t)(v)(v1)(v2)();
                        drawRightPane(t)(v)(v1)(v2)();
                        return Effect_Ref.write(new Data_Maybe.Just(v.timestamp))(v2.uiStateId)();
                    })();
                    drawHighlights(t)(v)(v2)();
                    drawDraggedOrgan(v)(v1)(v2)();
                    return debugInfo(v2)();
                };
            };
        };
    };
};
module.exports = {
    RendererState: RendererState,
    initDebug: initDebug,
    resetDebug: resetDebug,
    debugInfo: debugInfo,
    note: note,
    screenImageData: screenImageData,
    cacheScreen: cacheScreen,
    restore: restore,
    restoreAll: restoreAll,
    queueRestore: queueRestore,
    drawImageTemp: drawImageTemp,
    fillRectTemp: fillRectTemp,
    newRendererState: newRendererState,
    draw: draw,
    drawPlayerBoard: drawPlayerBoard,
    drawDeathMessage: drawDeathMessage,
    drawStats: drawStats,
    drawHp: drawHp,
    drawRedVision: drawRedVision,
    drawBlueVision: drawBlueVision,
    drawCenterPane: drawCenterPane,
    centerPaneMap: centerPaneMap,
    drawCenterPaneAnimations: drawCenterPaneAnimations,
    blink: blink,
    drawDraggedOrgan: drawDraggedOrgan,
    drawHighlights: drawHighlights,
    getHighlightColor: getHighlightColor,
    rectPos: rectPos,
    animPlayerRect: animPlayerRect,
    animEnemyRect: animEnemyRect,
    animItemRect: animItemRect,
    drawRightPane: drawRightPane,
    clear: clear,
    fillRect: fillRect,
    drawBoardBase: drawBoardBase,
    drawEnemyBoardDetails: drawEnemyBoardDetails,
    fromGrid: fromGrid,
    organImage: organImage,
    drawOrgan: drawOrgan,
    drawOrganTemp: drawOrganTemp,
    drawInjury: drawInjury,
    drawClue: drawClue,
    drawText: drawText,
    Color: Color,
    drawColorText: drawColorText,
    wrapText: wrapText,
    splitOnSize: splitOnSize,
    drawImage: drawImage,
    drawImageFull: drawImageFull,
    setTextBaselineHanging: $foreign.setTextBaselineHanging
};
